//Componentes Generales
import React, { useState, useEffect, useContext, useRef } from "react";
import NewProductItm from "../newProductItm/NewProductItm";
import SelectList from "../SelectList/SelectList";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';

//Contex
import productsContext from "../../context/productos/productsContext";
import reqsSectorsContext from "../../context/sectoresReqs/reqsSectorsContext";
import subCuentasContext from "../../context/subcuentas/subcuentasContext.js";
import warehousesContext from "../../context/depositos/warehousesContext";
import authContext from "../../context/authentication/authContex";

//Ruta para obtener sectores según depósito
import { getAbmWarehouseSectorsByDeposito } from "../../api/abmWarehouse.js";

//Tipos de Prioridades
import { PRIORITY, PRIORITYIN } from "../../utils/priority";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

// Estilos
import "./FormReq.css";

//Util
import { getMimeTypeFromFile } from "../../utils/files.js";
import Swal from "sweetalert2";

// Constante con estructura del producto.
const estructura_producto = {
  tipPro: "",
  artCod: "",
  codRed: "",
  descrp: "",
  quantity: "1",
  textAdic: "",
  price: 0,
  abmCodDim: "",
  abmCodDimDescrp: "",
  abmSubCue: "",
  abmSubCueDescrp: "",
  usr_id: (Math.random() * 100).toString(),
};
const createEstructuraProducto = () => ({
  tipPro: "",
  artCod: "",
  codRed: "",
  descrp: "",
  quantity: "1",
  textAdic: "",
  price: 0,
  abmCodDim: "",
  abmCodDimDescrp: "",
  abmSubCue: "",
  abmSubCueDescrp: "",
  usr_id: (Math.random() * 100).toString()
})

/*
    Componente encargado de mostrar el formulario de requerimiento.
        Donde edicion determina si mostrar algunas cosas y a que logica seguir en el guardado.
              req es la estructura del requerimiento.
              files son los archivos que almacena/ra el requerimiento.
              itemList son los items/productos del requerimeinto.
              guardarReq es la función del context que guarda el requerimiento.
              cerrar es la función encargada de ocultar el dialogo.
*/
function FormReq({ edicion, req, files = [], itemList, guardarReq, cerrar }) {
  //
  const [loading, setLoading] = useState(false);
  //State del requerimiento.
  const [requeriment, setRequeriment] = useState(req);
  //State que determina la muestra de las opciones de selección de estado.
  const [displayOptions, setDisplayOptions] = useState();
  //State de los items del requerimiento. El primero/ultimo es la constante definida al principio.
  const [items, setItems] = useState(
    itemList.length === 0
      ? [createEstructuraProducto()]
      : itemList.map(item => ({ ...item, usr_id: item.usr_id || (Math.random() * 100).toString() })).concat([createEstructuraProducto()])
  );
  //State de los archivos seleccionados.
  const [selectedFiles, setSelectedFiles] = useState(files);
  //State necesario para poder personalizar input de files.
  const [selectionColor, setSelectionColor] = useState(false);
  //State necesario para que el usuario no envie muchas veces el requerimiento cuando aprieta el boton muchas veces
  const [controlBotonEnviar, setControlBotonEnviar] = useState(false);
  //State de los sectores del depósito seleccionado
  const [warehouseSectors, setWarehouseSectors] = useState([]);
  //State que determina si cambió la selección del depósito (para resetear el sector de depósito)
  const [warehouseChanged, setWarehouseChanged] = useState(false);
  //Flag para saber cuando los datos de contexto ya fueron cargados
  const [dataLoaded, setDataLoaded] = useState(false);

  const pContext = useContext(productsContext);
  const { products, actualizarProducts } = pContext;

  const sRContext = useContext(reqsSectorsContext);
  const { reqsSectors, actualizarReqsSectors } = sRContext;

  const subCueContext = useContext(subCuentasContext);
  const { centrosCosto, actualizarCentrosCosto, tiposCosto, actualizarTiposCosto } = subCueContext;

  const dContext = useContext(warehousesContext);
  const { warehouses, actualizarWarehouses } = dContext;

  const aContext = useContext(authContext);
  const { usuario } = aContext;

  const inputFileRef = useRef(null);

  const navigate = useNavigate();

  /* 
        Disparador que actualiza la lista de productos disponibles 
        al momento de renderizar el componente.
    */
  useEffect(() => {
    const fn = async () => {
      setLoading(true);
      try {
        await actualizarProducts();
        await actualizarReqsSectors();
        await actualizarCentrosCosto();
        await actualizarTiposCosto();
        await actualizarWarehouses();
        setDataLoaded(true);
      } catch (error) {
        console.error("Error al cargar los datos del contexto", error);
      } finally {
        setLoading(false);
      }
    };
    fn();
  }, []);

  // Pre-rellena sector, depósito y sector de depósito desde los defaults del usuario
  // cuando los datos ya están cargados y el usuario está disponible
  useEffect(() => {
    if (!dataLoaded || edicion === "Edicion" || !usuario || !usuario.tDocAbmReqSectorCodsem) return;

    const preFill = async () => {
      try {
        const sectorReq = reqsSectors && reqsSectors.find(
          (s) => s.codSem.replace(/\s+/g, "") === usuario.tDocAbmReqSectorCodsem.replace(/\s+/g, "")
        );
        const warehouse = warehouses && warehouses.find(
          (w) => w.deposi.replace(/\s+/g, "") === (usuario.abmWarehouseDeposi || "").replace(/\s+/g, "")
        );

        let warehouseSectorDescrp = "";
        let whSectors = [];
        if (usuario.abmWarehouseDeposi) {
          const respWS = await getAbmWarehouseSectorsByDeposito(usuario.abmWarehouseDeposi);
          whSectors = respWS.data.data || [];
          const ws = whSectors.find(
            (s) => s.sector.replace(/\s+/g, "") === (usuario.abmWarehouseSectorSector || "").replace(/\s+/g, "")
          );
          warehouseSectorDescrp = ws ? ws.descrp : "";
        }

        setWarehouseSectors(whSectors);
        setRequeriment((prev) => ({
          ...prev,
          tDocAbmReqSectorCodsem: usuario.tDocAbmReqSectorCodsem,
          tDocAbmReqSectorDescrp: sectorReq ? sectorReq.descrp : "",
          tDocAbmWarehouseDeposi: usuario.abmWarehouseDeposi || "",
          tDocAbmWarehouseDescrp: warehouse ? warehouse.descrp : "",
          tDocAbmWarehouseSectorSector: usuario.abmWarehouseSectorSector || "",
          tDocAbmWarehouseSectorDescrp: warehouseSectorDescrp,
        }));
      } catch (error) {
        console.error("Error al pre-rellenar datos del usuario", error);
      }
    };
    preFill();
  }, [dataLoaded, usuario]);

  /*
        Manejador de requerimiento ante cambio de titulo.
            Donde data es el titulo ingresada por el usuario. 
        El parametro data es el valor con el que se setea el titulo del requerimiento.
    */
  const handleChangeTitle = (data) => {
    setRequeriment({ ...requeriment, title: data });
  };

  /*
        Manejador de requerimiento ante cambio de fecha Entrega.
            Donde data es la fecha Entrega ingresada por el usuario. 
        El parametro data es el valor con el que se setea la fecha Entrega del requerimiento.
    */
  const handleChangeDate = (data, dateReason) => {
    const fecha = new Date(data.concat("T15:00:00.000Z"));
    setRequeriment({ ...requeriment, [dateReason]: fecha });
  };

  /*
        Manejador de requerimiento ante cambio de observación.
            Donde data es la observación ingresada por el usuario. 
        El parametro data es el valor con el que se setea la observación del requerimiento.
    */
  const handleChangObservation = (data) => {
    setRequeriment({ ...requeriment, observ: data });
  };

  const handleChangeReqSector = (value) => {
    const sectorReqSeleccionado = reqsSectors.find(
      (rS) =>
        `${rS.codSem}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (sectorReqSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        tDocAbmReqSectorCodsem: sectorReqSeleccionado.codSem,
        tDocAbmReqSectorDescrp: sectorReqSeleccionado.descrp,
      });
    }
  };

  const handleChangeWarehouse = async (value) => {
    setRequeriment((prevRequeriment) => ({
      ...prevRequeriment,
      tDocAbmWarehouseDeposi: "",
      tDocAbmWarehouseSectorSector: "",
      tDocAbmWarehouseSectorDescrp: "",
    }));

    setWarehouseChanged(true);

    const depositoSeleccionado = warehouses.find(
      (w) =>
        `${w.deposi}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (depositoSeleccionado !== undefined) {
      const respWarehouseSectors = await getAbmWarehouseSectorsByDeposito(
        depositoSeleccionado.deposi
      );

      const sectores = respWarehouseSectors.data.data;
      setWarehouseSectors(sectores);

      const primerSector = sectores.length > 0 ? sectores[0] : null;

      setRequeriment((prevRequeriment) => ({
        ...prevRequeriment,
        tDocAbmWarehouseDeposi: depositoSeleccionado.deposi,
        tDocAbmWarehouseDescrp: depositoSeleccionado.descrp,
        tDocAbmWarehouseSectorSector: primerSector ? primerSector.sector : "",
        tDocAbmWarehouseSectorDescrp: primerSector ? primerSector.descrp : "",
      }));

      setWarehouseChanged(false);
    }
  };

  const handleChangeWarehouseSector = (value) => {
    setWarehouseChanged(false);
    const sectorDepositoSeleccionado = warehouseSectors.find(
      (wS) =>
        `${wS.sector}`.replace(/\s+/g, "") ===
        value.value.split(" ~ ")[0].replace(/\s+/g, "")
    );

    if (sectorDepositoSeleccionado !== undefined) {
      setRequeriment({
        ...requeriment,
        tDocAbmWarehouseSectorSector: sectorDepositoSeleccionado.sector,
        tDocAbmWarehouseSectorDescrp: sectorDepositoSeleccionado.descrp,
      });
    }
  };

  /* 
        Manejador encargado de agregar un item a los items del requerimiento.
            Donde data es el producto a añadir a los items.
        Se agrega el producto seleccionado y al final se agrega un item vacio (Constante estructura del producto).
    */
  const handleagregaItem = (data) => {
    //Se le asigna un id random al nuevo producto añadido. Esto es para facilitar la eliminación del item en caso de ser necesario.
    const tempData = { ...data, usr_id: (Math.random() * 100).toString() };
    //Se le asigna un id random al item vacio. Esto es para facilitar la eliminación del item en caso de ser necesario.
    const nuevaEstructura = {
      ...estructura_producto,
      usr_id: (Math.random() * 100).toString(),
    };
    //Logica para determinar donde inserta el item vacio.
    const temp_List = items.length === 1 ? [nuevaEstructura] : items;
    const newLista =
      temp_List.length === 1
        ? [tempData, ...temp_List]
        : [
            ...temp_List.filter((d) => d.artCod !== ""),
            tempData,
            nuevaEstructura,
          ];

    setItems(newLista);
  };

  /*
        Manejador encargado de eliminar un item de los items del requerimiento.
            Donde item es el item completo a eliminar.
            Donde i es la posición del item a eliminar.
        Setea los items despues de filtrar la posición indicada por parametro.
    */
  const handleDeleteConcept = (item, i) => {
    if (i !== items.length - 1) {
      setItems(
        items.filter((data, index) => {
          if (index !== i) {
            return data;
          }
        })
      );
    }
  };

  /* 
        Manejador ante cambio en los items.
            Donde data es el item modificado.
            Donde i es la posición del item modificado
        Setea los items despues de reemplazar  el item por el recibido por parametro.
    */
  const handleChangeItm = (data, i) => {
    const newLista = items.map((it, index) => {
      return index === i ? data : it;
    });
    setItems(newLista);
  };

  /*
        Manejador ante selección de una prioridad.
            Donde priorIndex es el codigo identificativo de la prioridad.
        Al setear la prioridad en el requerimiento, se oculta el desplegable de opciones de prioridades disponibles.
    */
  const seleccionarPriority = (priorIndex) => {
    displayOpciones();
    setRequeriment({ ...requeriment, priority: priorIndex });
  };

  /* 
        Determina si se muestra o no el display de opciones de prioridades.
    */
  const displayOpciones = () => {
    displayOptions ? setDisplayOptions(false) : setDisplayOptions(true);
  };

  /* 
        Manejador encargado de agregar archivos al requerimiento.
            Donde e es el archivo subido por el usuario.
    */
  const handleFileInputChange = (e) => {
    if (e.target.files.length === 0) return;

    const files = Array.from(e.target.files);

    const validFiles = files.filter((file) => {
      const detectedMimeType = getMimeTypeFromFile(file.name);

      // Validar tipo MIME permitido
      if (!detectedMimeType) {
        Swal.fire({
          title: "Ops!",
          text: `Tipo de archivo no permitido o desconocido (${file.name})`,
          icon: "error",
        });
        return false; // excluye el archivo
      }

      return true; // incluye el archivo válido
    });

    if (validFiles.length > 0) {
      setSelectedFiles((prev) => [...prev, ...validFiles]);
    }

    // Limpia el input para poder volver a seleccionar los mismos archivos más tarde
    e.target.value = null;
  };

  /*
        Guarda el requerimiento mediante función del context.
        Distintos comportamientos segun variable edición.
    */
  const handleSaveRequirement = async () => {
    setControlBotonEnviar(true); // Bloqueo el botón mientras se esta enviando el requerimiento.
    const newLista = items.filter((d) => d.artCod !== "");

    // 🔹 Procesar todos los archivos seleccionados antes de enviar
    const processedFiles = selectedFiles.map((file) => {
      const name = file.name || "";
      const size = file.size || 0;
      const uri = file.uri || "";
      const mimeType = file.type || "";

      const safeName = name.replace(/[(){}\[\]áéíóúÁÉÍÓÚñÑ&#¿¡`^¨*]/g, "%");
      return {
        ...file,
        name: safeName,
        size,
        uri,
        type: mimeType,
      };
    });
    let resp;
    if (edicion === "Edicion") {
      resp = await guardarReq(requeriment, newLista, selectedFiles, files);
      setControlBotonEnviar(false); // Habilitar el botón nuevamente
      // Solo cerrar si la respuesta fue exitosa
      if (resp) {
        cerrar();
      }
    } else {
      resp = await guardarReq(requeriment, newLista, selectedFiles);
      setControlBotonEnviar(false); // Habilitar el botón nuevamente
      if (resp) {
        setRequeriment({ ...req });
        setItems([estructura_producto]);
        setSelectedFiles([]);
        if (edicion == "Guardar_Como") {
          cerrar();
        } else {
          navigate("/Home");
        }
      }
    }
  };

  /* 
        Manejador encargado de eliminar archivos al requerimiento.
            Donde aborrar es el archivo borrado por el usuario.
    */
  const eliminaFile = (aborrar) => {
    const array = Array.from(selectedFiles);
    setSelectedFiles(array.filter((data) => data.name !== aborrar.name));
  };

  /*
        Función necesaria para poder personalizar input de files.
    */
  const cambioColorSeleccion = () => {
    setSelectionColor(!selectionColor);
  };

  const handleFileXLSX = (file) => {
    if(file){
      const reader = new FileReader();
      reader.onload = (evt) => {
          const binaryString = evt.target.result;
          const wb = XLSX.read(binaryString, {type: 'binary'});
          const sheet = wb.Sheets[wb.SheetNames[0]];
          const jsonData = XLSX.utils.sheet_to_json(sheet,{header:1});
          try {
            let firstRowTemplate = jsonData[0] ?? {};

            if(firstRowTemplate[0] != 'TIPPRO' || firstRowTemplate[1] != 'ARTCOD' || firstRowTemplate[2] != 'CANTID' || firstRowTemplate[3] != 'TEXT ADIC' || firstRowTemplate[4] != 'TCC' || firstRowTemplate[5] != 'CCO'){
              Swal.fire({
                title: 'Ops!',
                html: 'Las columnas del archivo cargado no coinciden con las provistas por el template .xlsx.<br/>Por favor, descarge el template, completelo e intente nuevamente.',
                icon: 'error'
              });
              return;
            }
            
            let dataModelated = jsonData.filter((p,i) => i > 0 && p.length > 0).map((p) => {
              let objectModelated;
              
              const productoSeleccionado = products.find((pr) => `${pr.tipPro}${pr.artCod}`.replace(/\s+/g, "") === `${p[0]}${p[1]}`.replace(/\s+/g, ""));
              
              const tipoCostoSeleccionado = tiposCosto.find(
                (tC) =>
                  `${tC.subCue}`.replace(/\s+/g, "") === p[4].replace(/\s+/g, "")
              );

              const centroCostoSeleccionado = centrosCosto.find(
                (cC) =>
                  `${cC.subCue}`.replace(/\s+/g, "") === p[5].replace(/\s+/g, "")
              );

              if(productoSeleccionado){
                objectModelated = {
                  tipPro: productoSeleccionado.tipPro,
                  artCod: productoSeleccionado.artCod,
                  descrp: productoSeleccionado.descrp,
                  price: productoSeleccionado.price,
                  uniMed: productoSeleccionado.uniMed,
                  quantity: p[2],
                  textAdic: p[3],
                  tipoCosto:{
                    abmCodDim: 'TCC',
                    abmCodDimDescrp: 'Tipo de centro de costo (Rubro)',
                    abmSubCue: p[4],
                    abmSubCueDescrp: tipoCostoSeleccionado.subCueDescrp
                  },
                  centroCosto:{
                    abmCodDim: 'COO',
                    abmCodDimDescrp: 'Centro de Costo',
                    abmSubCue: p[5],
                    abmSubCueDescrp: centroCostoSeleccionado.subCueDescrp
                  },
                  usr_id: (Math.random() * 100).toString(),
                }
              }

              return objectModelated;
          }).filter(p => p);

          setItems(prevItems => {
            let newItems = prevItems.filter(p => p.artCod).map(p => p);
            return [...newItems, ...dataModelated, {...createEstructuraProducto()}];
          })

        } catch (error) {
          console.log("error intentando leer y cargar excel");
          console.log(error);
        }
      }
      reader.readAsBinaryString(file);
    }
  }

  const handleChangeXLSX = (e) => {
    const file = e.target.files[0];
    handleFileXLSX(file);
  }

  const handleDropXLSX = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];
    handleFileXLSX(droppedFile);
  }

  if (loading) {
    return (
      <div className="formreq-loading-overlay">
        <div className="formreq-spinner"></div>
      </div>
    );
  } else {
    return (
      <div className="container-gr-addreq">
        <div className="container-r-list-item-header">
          <input
            placeholder="Ingrese un título..."
            className="list-item-header-title-addReq"
            value={requeriment.title}
            onChange={(data) => handleChangeTitle(data.target.value)}
            autoFocus={true}
            style={{ fontWeight: "bold" }}
            maxLength={60}
          ></input>
          <div className="container-prioritys-gral">
            <div
              className={
                requeriment.priority === 2
                  ? "r-list-item-header-priority-urgente  margin-right-r"
                  : requeriment.priority === 1
                  ? "r-list-item-header-priority-alta  margin-right-r"
                  : "r-list-item-header-priority-media  margin-right-r"
              }
              onClick={displayOpciones}
            >
              {PRIORITY[requeriment.priority ? requeriment.priority : 0]}
            </div>
            {displayOptions && (
              <div className="options-container-fr  margin-right-r">
                <div className="options-container-fr-back">
                  {PRIORITY.map((prior) => {
                    return (
                      <div
                        key={prior}
                        className={
                          PRIORITYIN[prior] === 2
                            ? "r-list-item-header-priority-urgente"
                            : PRIORITYIN[prior] === 1
                            ? "r-list-item-header-priority-alta"
                            : "r-list-item-header-priority-media"
                        }
                        value={prior}
                        onClick={() => seleccionarPriority(PRIORITYIN[prior])}
                      >
                        {prior}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
          {edicion && (
            <FontAwesomeIcon
              style={{ cursor: "pointer" }}
              icon={faXmark}
              onClick={() => cerrar(null)}
            />
          )}
        </div>
        <div className="container-AddReq-item-gral">
          <div className="container-AddReq-item-details">
            <div className="container-r-item-title-details">
              Fecha de Entrega
            </div>
            <input
              type="date"
              className="label-AddReq-fecha"
              value={moment.utc(requeriment.deliveryDate).format("YYYY-MM-DD")}
              onChange={(data) =>
                handleChangeDate(data.target.value, "deliveryDate")
              }
            />
          </div>
          <div
            className="container-AddReq-item-details"
            style={{ marginLeft: "80px" }}
          >
            <div className="container-r-item-title-details">
              Fecha de Movimiento
            </div>
            <input
              type="date"
              className="label-AddReq-fecha"
              value={moment.utc(requeriment.fchMov).format("YYYY-MM-DD")}
              onChange={(data) => handleChangeDate(data.target.value, "fchMov")}
            />
          </div>
        </div>
        <div className="container-AddReq-item-details-text">
          <SelectList
            text={"Sector de Requerimientos"}
            options={reqsSectors.map((rS) => {
              return {
                value: `${rS.codSem}`,
                label: `${rS.codSem}  (${rS.descrp})`,
              };
            })}
            handleChange={handleChangeReqSector}
            property={"Sector de Requerimientos"}
            valueAux={{
              label:
                requeriment.tDocAbmReqSectorCodsem &&
                requeriment.tDocAbmReqSectorDescrp
                  ? `${requeriment.tDocAbmReqSectorCodsem} (${requeriment.tDocAbmReqSectorDescrp})`
                  : "",
              value: requeriment.tDocAbmReqSectorCodsem || "",
            }}
            emptyInputs={[]}
          />
        </div>
        <div className="container-AddReq-item-details-text">
          <SelectList
            text={"Depósito"}
            options={warehouses.map((w) => {
              return {
                value: `${w.deposi}`,
                label: `${w.deposi}  (${w.descrp})`,
              };
            })}
            handleChange={handleChangeWarehouse}
            property={"Depósitos"}
            valueAux={{
              label:
                requeriment.tDocAbmWarehouseDeposi &&
                requeriment.tDocAbmWarehouseDescrp
                  ? `${requeriment.tDocAbmWarehouseDeposi} (${requeriment.tDocAbmWarehouseDescrp})`
                  : "",
              value: requeriment.tDocAbmWarehouseDeposi || "",
            }}
            emptyInputs={[]}
          />
        </div>
        <div className="container-AddReq-item-details-text" style={{ display: "none" }}>
          <SelectList
            text={"Sector de Depósito"}
            options={warehouseSectors.map((wS) => {
              return {
                value: `${wS.sector}`,
                label: `${wS.sector}  (${wS.descrp})`,
              };
            })}
            handleChange={handleChangeWarehouseSector}
            property={"Sectores de Depósito"}
            valueAux={{
              label:
                requeriment.tDocAbmWarehouseSectorSector &&
                requeriment.tDocAbmWarehouseSectorDescrp &&
                warehouseChanged === false
                  ? `${requeriment.tDocAbmWarehouseSectorSector} (${requeriment.tDocAbmWarehouseSectorDescrp})`
                  : "",
              value: requeriment.tDocAbmWarehouseSectorSector || "",
            }}
            emptyInputs={[]}
          />
        </div>
        <div className="container-AddReq-item-details-text">
          <div className="container-r-item-title-details">Texto Adicional</div>
          <div className="container-input-texto">
            <div className="r-text-adic">
              <textarea
                placeholder="Ingrese texto adicional"
                className="r-item-text-input"
                style={{ fontWeight: 600 }}
                value={requeriment.observ}
                onChange={(data) => handleChangObservation(data.target.value)}
              ></textarea>
            </div>
          </div>
        </div>
        <div className="container-AddReq-item-details-items">
          <div className="container-r-item-title-details">
            Items: {items.length === 0 ? 0 : items.length - 1}
          </div>
          <div className="container-items-products-rq-gral" onDragOver={e => e.preventDefault()} onDrop={handleDropXLSX} style={{borderStyle:'dotted', borderWidth: 4, borderColor: 'lightblue', padding: 4}}>
            {items.length > 0 &&
              items.map((c, index) => {
                return (
                  <NewProductItm
                    data={c}
                    index={index}
                    key={c.usr_id}
                    edicion={edicion}
                    productsList={products.filter(p => p.debaja !== 'S')}
                    agregaItem={(data) => handleagregaItem(data)}
                    modificaItm={(data, indice) =>
                      handleChangeItm(data, indice)
                    }
                    borraItem={() => handleDeleteConcept(c, index)}
                    tiposCosto={tiposCosto}
                    centrosCosto={centrosCosto}
                  />
                );
              })}
              <div className="handleExcelOptionsDiv">
                <a href="/prodsReqXProvCASMOVI.xlsx" download>Descargar template.xlsx</a>
                <h5><button className="selectFileXLSXBtn" onClick={()=>inputFileRef.current.click()}>Seleccione</button> o suelte en el area punteada un archivo .xlsx para cargar sus productos</h5>
                <input ref={inputFileRef} accept=".xlsx,.xls" type="file" onChange={e => handleChangeXLSX(e)} style={{display:'none'}}/>
              </div>
          </div>
        </div>
        <div>
          <div className="container-button-rq-save-new2">
            <div
              className={
                selectionColor
                  ? "button-rq-save-new2-selected"
                  : "button-rq-save-new2"
              }
            >
              <div className="file-select" id="src-file1">
                <input
                  onFocus={cambioColorSeleccion}
                  onBlur={cambioColorSeleccion}
                  type="file"
                  name="src-file1"
                  aria-label="Agregar Archivo"
                  multiple
                  onChange={handleFileInputChange}
                />
              </div>
            </div>
          </div>
          <div className="container-new-rq-files">
            <ul className="container-new-rq-files-details">
              {selectedFiles.map((file) => (
                <li key={file.name}>
                  {file.name}
                  <FontAwesomeIcon
                    onClick={() => eliminaFile(file)}
                    style={{
                      cursor: "pointer",
                      color: "red",
                      marginLeft: "20px",
                    }}
                    icon={faXmark}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="container-button-rq-save-new">
          <button
            className="button-rq-save-new"
            disabled={controlBotonEnviar}
            onClick={handleSaveRequirement}
          >
            Finalizar
          </button>
        </div>
      </div>
    );
  }
}

export default FormReq;